module.exports = __webpack_public_path__ + "img/title.3cad082d.png";